<template>
  <div class="description">
    <div v-if="title" class="title">{{ title }}</div>
    <el-row :gutter="gutter">
      <el-col :key="key" :span="+col" v-for="(item, key) in dataList">
        <div class="label">{{ item.label }}</div>
        <div class="detail" v-if="item.type === 'text'">{{ item.detail }}</div>
        <div class="detail" v-else-if="item.type === 'link'">
          <el-link class="link" :href="item.href" target="_blank">{{ item.detail }}</el-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
const handleArrayObj = data => {
  return data
    .filter(item => item.tag === "description-item")
    .map(item => ({
      tag: item.tag,
      label: (item.data && item.data.attrs.label) || "暂无",
      type: (item.data && item.data.attrs.type) || "text",
      href: (item.data && item.data.attrs.href) || "#",
      detail: (item.children && item.children[0].text) || "暂无"
    }));
};

export default {
  name: "Descriptions",
  props: {
    title: String,
    gutter: {
      type: [Number, String],
      default: 20
    },
    col: {
      type: [Number, String],
      default: 8
    }
  },

  data() {
    return {
      dataList: handleArrayObj(this.$slots.default || [])
    };
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.description {
  .title {
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 15px;
    color: #17ECFE;
  }

  .label {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 16px;
    margin-right: 8px;
    white-space: nowrap;
    display: table-cell;

    &:after {
      content: ":";
      margin: 0 8px 0 2px;
      position: relative;
      top: -0.5px;
    }
  }

  .detail {
    font-size: 14px;
    line-height: 1.5;
    width: 100%;
    padding-bottom: 16px;
    display: table-cell;
    color: #FFFFFF;
  }
}
</style>
